import { render, staticRenderFns } from "./address.vue?vue&type=template&id=48a7c26c"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a7c26c')) {
      api.createRecord('48a7c26c', component.options)
    } else {
      api.reload('48a7c26c', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=48a7c26c", function () {
      api.rerender('48a7c26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/address.vue"
export default component.exports